"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HelpTopicCard = HelpTopicCard;
exports.InfoCard = InfoCard;
exports.ViewAllCard = ViewAllCard;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _grommet = require("grommet");
var _grommetIcons = require("grommet-icons");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _reactI18next = require("react-i18next");
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["id", "Icon", "iconColor", "children", "onClick", "testId"];
var _templateObject, _templateObject2;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _objectDestructuringEmpty(t) { if (null == t) throw new TypeError("Cannot destructure " + t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
var StyledCard = (0, _styledComponents["default"])(_grommet.Card)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  &:hover {\n    box-shadow: 0px 3px 6px #0000003d;\n    font-weight: 500;\n  }\n"])));
function HelpTopicCard(_ref) {
  var _id$split$;
  var id = _ref.id,
    Icon = _ref.Icon,
    iconColor = _ref.iconColor,
    children = _ref.children,
    _onClick = _ref.onClick,
    testId = _ref.testId,
    rest = _objectWithoutProperties(_ref, _excluded);
  // By convention the id contains the resourceId after __
  var resourceId = id === null || id === void 0 || (_id$split$ = id.split('__')[1]) === null || _id$split$ === void 0 ? void 0 : _id$split$.toLowerCase();
  // 'glcp-test-123'

  return /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledCard, _objectSpread(_objectSpread({
    id: id,
    fill: "horizontal",
    direction: "row",
    border: {
      color: 'border-weak'
    },
    elevation: "none",
    flex: false,
    margin: {
      bottom: 'small'
    },
    onClick: function onClick() {
      if (_onClick) {
        _onClick(resourceId);
      }
    },
    "data-testid": "".concat(testId, "--").concat(resourceId || '')
  }, rest), {}, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_grommet.Box, {
      direction: "row",
      gap: "small",
      pad: "small",
      align: "start",
      children: [Icon && /*#__PURE__*/(0, _jsxRuntime.jsx)(_grommet.Box, {
        pad: {
          top: 'xxsmall'
        },
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(Icon, {
          color: iconColor,
          size: "18px",
          "aria-label": ""
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_grommet.Box, {
        "data-testid": "".concat(testId, "--").concat(resourceId || '', "--text"),
        children: children
      })]
    })
  }));
}
HelpTopicCard.propTypes = {
  id: _propTypes["default"].string,
  Icon: _propTypes["default"].any,
  iconColor: _propTypes["default"].string,
  children: _propTypes["default"].any,
  onClick: _propTypes["default"].func,
  testId: _propTypes["default"].string.isRequired
};
function InfoCard(_ref2) {
  var rest = _extends({}, (_objectDestructuringEmpty(_ref2), _ref2));
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(HelpTopicCard, _objectSpread({
    Icon: _grommetIcons.CircleInformation,
    background: "background-contrast",
    margin: {
      top: 'medium'
    }
  }, rest));
}

// Fix spacing for positioning after the link
var StyledShareRounded = (0, _styledComponents["default"])(_grommetIcons.ShareRounded)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  margin-bottom: -3px;\n  margin-left: 2px;\n"])));
function ViewAllCard(_ref3) {
  var viewAllUrl = _ref3.viewAllUrl,
    testId = _ref3.testId;
  var _useTranslation = (0, _reactI18next.useTranslation)(),
    t = _useTranslation.t;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(HelpTopicCard, {
    Icon: _grommetIcons.Info,
    iconColor: "brand",
    border: {
      color: 'brand'
    },
    background: "validation-ok",
    testId: testId,
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_grommet.Text, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_grommet.Text, {
        weight: "bold",
        children: t('view_all_lbl')
      }), ' ', /*#__PURE__*/(0, _jsxRuntime.jsx)(_grommet.Anchor, {
        href: viewAllUrl,
        target: "help",
        "data-testid": "".concat(testId, "-anchor"),
        children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_grommet.Text, {
          weight: "normal",
          children: [t('view_all_lnk'), /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledShareRounded, {
            size: "small"
          })]
        })
      })]
    })
  });
}
ViewAllCard.propTypes = {
  viewAllUrl: _propTypes["default"].string,
  testId: _propTypes["default"].string.isRequired
};